module.exports = __webpack_public_path__ + "static/img/211.2c745d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/211.png
// module id = 9klZ
// module chunks = 1